module.exports = __webpack_public_path__ + "img/loading.6cbfea32.png";